// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1___9a023fb2a7a4cc4db8c","cls2":"ProfileBulkFollowModal-cls2__f1e41d78abe2ce1a0838 ProfileBulkFollowModal-cls1___9a023fb2a7a4cc4db8c"};